import { useResourceNameModal } from '@hooks/useModal'
import { useRenameApprovalGroup } from '../hooks/useApprovalGroupsManagement'
import { useTranslation } from 'react-i18next'

export const useEditApprovalGroup = () => {
  const { openResourceNameModal } = useResourceNameModal()
  const updateApprovalGroup = useRenameApprovalGroup()
  const { t } = useTranslation()

  const edit = (approvalGroup: AdminApprovalGroup) => {
    openResourceNameModal({
      title: t('features.approvalGroupsAdmin.editApprovalGroupTitle'),
      inputLabel: t('features.approvalGroupsAdmin.groupName'),
      initialValue: approvalGroup.name,
      onSave: async (name: string) => {
        await updateApprovalGroup.mutateAsync({ id: approvalGroup.id, name })
      },
      toastMessages: {
        success: {
          title: t('features.approvalGroupsAdmin.approvalGroupSaved'),
          content: (name) => t('features.approvalGroupsAdmin.successfullySavedApprovalGroup', { name }),
        },
        error: {
          title: t('features.approvalGroupsAdmin.unableToSaveApprovalGroup'),
          content: t('features.approvalGroupsAdmin.failedToSaveApprovalGroup'),
        },
      },
    })
  }

  return { edit }
}
